<template>
  <div class="empty-state">
    <FishIcon :nome="icone" tamanho="enorme" class="empty-state__icone repouso-flutua" />

    <p class="empty-state__titulo t-subtitulo">{{ titulo }}</p>
    <p v-if="explicacao" class="empty-state__explicacao t-corpo">{{ explicacao }}</p>

    <!--
      A CHAMADA — a parte que faz um estado vazio valer a pena.

      O UI-20 não é "faltam ilustrações": é que "Iscas" e "Barcos" apareciam como **cabeçalhos
      órfãos** no Inventário. Um cabeçalho seguido de nada é a tela dizendo que algo quebrou. Um
      estado vazio que diz o que fazer é a tela dando o próximo passo — e o passo quase sempre é a
      Loja.
    -->
    <slot name="acao">
      <FishButton v-if="acao" variante="primario" :icone="iconeDaAcao" @click="$emit('acao')">
        {{ acao }}
      </FishButton>
    </slot>
  </div>
</template>

<script>
import FishIcon from './FishIcon.vue';
import FishButton from './FishButton.vue';

/**
 * 2.8 — `EmptyState` (UI-20).
 *
 * ## Onde ele já tem lugar marcado
 *
 * - **Inventário**, nas abas de Iscas e Barcos — o defeito que originou o UI-20;
 * - **a barraca do clã** cujo líder não repôs nada (D24, 7.4n): *"vê a barraca vazia, com a
 *   explicação — é o EmptyState fazendo o trabalho de dizer o que falta, não uma prateleira muda"*;
 * - **a parede de troféus** do perfil de um jogador novo (D29, 7.27b) — só que ali o vazio é
 *   `molduras vazias com silhuetas`, não este componente: "cabe isto aqui" é mais forte que uma
 *   frase;
 * - o quadro do clã sem atividade, a lista de pedidos sem pedido, o mural sem recado.
 *
 * ## Por que o ícone flutua
 *
 * D10-3: *"nada perfeitamente parado."* Um estado vazio absolutamente estático parece uma tela que
 * não carregou — que é exatamente a confusão que ele existe para desfazer. O repouso lento diz
 * "isto é uma tela pronta, e ela está vazia de propósito".
 */
export default {
  name: 'EmptyState',
  components: { FishIcon, FishButton },
  props: {
    icone: { type: String, default: 'nav-inventario' },
    titulo: { type: String, required: true },
    /** O porquê, e o que muda isso. Nunca "nada aqui" — isso o jogador já viu. */
    explicacao: { type: String, default: '' },
    acao: { type: String, default: '' },
    iconeDaAcao: { type: String, default: 'nav-loja' },
  },
  emits: ['acao'],
};
</script>

<style scoped>
.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--e-3);
  padding: var(--e-7) var(--e-4);
  text-align: center;
}

.empty-state__icone {
  opacity: 0.5;
}

.empty-state__titulo {
  color: var(--tinta);
  margin: 0;
}

.empty-state__explicacao {
  color: var(--tinta-fraca);
  max-width: 38ch; /* a medida de leitura: linha mais longa que isso cansa e ninguém lê */
  margin: 0;
}
</style>
